// extracted by css-extract-rspack-plugin
module.exports =  {"commonBlockWrap":"cjvIz","common_block":"OEa45"};